import axios from "axios";
const http = axios.create({
    // API基础URL
    baseURL: 'http://api.msam.net.cn',
        // baseURL: 'http://api.sanpang.xyz',
    // 请求超时时间
    timeout: 5000, 
    // 其他axios配置...
})
// 添加请求拦截器
http.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    try {
        const storedLang = typeof window !== 'undefined' ? window.localStorage.getItem('lang') : null;
        const lang = storedLang || 'zh';
        // 将语言作为查询参数附加到所有请求
        const originalParams = config.params || {};
        config.params = {
            ...originalParams,
            language: lang
        };
    } catch (e) {
        // ignore storage issues
    }
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});
// 添加响应拦截器
http.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response.data;
  }, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
})
export default http;